// extracted by mini-css-extract-plugin
module.exports = {"deleteWrapper":"Delete_deleteWrapper__EchRv","deleteText":"Delete_deleteText__WEVt1","deleteButtonsWrapper":"Delete_deleteButtonsWrapper__Bmg2y"};